<script>
    // @ts-nocheck
    import { locale } from 'svelte-i18n'
    import { supportedLocales } from '$lib/i18n/index.js'
    import { page } from '$app/stores'
    import Cookies from 'js-cookie'
    import { dev } from '$app/environment'

    let opened = false

    $: restOfTheLanguages = supportedLocales.filter(item => item !== $locale)

    /**
     * This function is used to update the locale in the URL
     *
     * @param {string} locale
     */
    $: getUrlWithUpdatedLocale = locale => {
        if (!$page.route.id) {
            return `/${locale}`
        }

        const routeWithUpdatedLocale = $page.route.id.replace('[locale=locale]', locale)
        // Update rest of the route placeholders
        const routeWithAllParams = routeWithUpdatedLocale.replace(/\[(.*?)]/g, (match, placeholder) => {
            const paramName = placeholder.split('=')[0]
            return $page.params[paramName] || placeholder
        })
        return routeWithAllParams
    }

    /**
     * Update the selected language to the cookie, then continue navigation
     *
     * @param {Event} e
     * @param {string} lang
     */
    const onLanguageSelected = (e, lang) => {
        e.preventDefault()

        Cookies.set('selected-language', lang.toLowerCase(), {
            domain: dev ? undefined : 'sirupay.com',
            expires: 2000,
        })
        // Continue navigation
        window.location.href = e.target.href
    }
</script>

<div class="dropdown mr-2 d-inline">
    <button
        id="language-switcher-button"
        class="dropdown-toggle btn btn-sm border-0 bg-transparent text-secondary"
        type="button"
        aria-expanded={!!opened}
        on:click={() => (opened = !opened)}
    >
        {$locale.toUpperCase()}
    </button>
    <ul class={`dropdown-menu position-absolute ${opened ? 'show' : ''}`} aria-labelledby="language-switcher-button">
        {#each restOfTheLanguages as language}
            <li>
                <a
                    class="dropdown-item text-secondary"
                    on:click={e => onLanguageSelected(e, language)}
                    data-sveltekit-reload
                    href={getUrlWithUpdatedLocale(language)}>{language.toUpperCase()}</a
                >
            </li>
        {/each}
    </ul>
</div>

<style lang="scss">
    :global(.dropdown-menu) {
        min-width: 60px;
        right: 0;
        transform: translate3d(0, 5px, 0);
    }
</style>
